"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RangeMode = exports.PriceTierThresholdType = exports.PriceTierMethod = void 0;
var PriceTierMethod;
(function (PriceTierMethod) {
    PriceTierMethod["UNIT"] = "UNIT";
    PriceTierMethod["WEIGHT"] = "WEIGHT";
    PriceTierMethod["BULK"] = "BULK_WEIGHT";
    PriceTierMethod["PRICE_BASED"] = "PRICE_BASED";
})(PriceTierMethod = exports.PriceTierMethod || (exports.PriceTierMethod = {}));
;
var PriceTierThresholdType;
(function (PriceTierThresholdType) {
    PriceTierThresholdType["FLAT"] = "FLAT";
    PriceTierThresholdType["PERCENTAGE"] = "PERCENTAGE";
})(PriceTierThresholdType = exports.PriceTierThresholdType || (exports.PriceTierThresholdType = {}));
;
var RangeMode;
(function (RangeMode) {
    RangeMode["FIXED_PRICE"] = "FIX_PRICE";
    RangeMode["RANGE"] = "RANGE";
})(RangeMode = exports.RangeMode || (exports.RangeMode = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicHJpY2VUaWVyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3NoYXJlZFR5cGluZ3MvcHJpY2VUaWVyLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVBLElBQVksZUFLWDtBQUxELFdBQVksZUFBZTtJQUN2QixnQ0FBYSxDQUFBO0lBQ2Isb0NBQWlCLENBQUE7SUFDakIsdUNBQW9CLENBQUE7SUFDcEIsOENBQTJCLENBQUE7QUFDL0IsQ0FBQyxFQUxXLGVBQWUsR0FBZix1QkFBZSxLQUFmLHVCQUFlLFFBSzFCO0FBQUEsQ0FBQztBQUVGLElBQVksc0JBR1g7QUFIRCxXQUFZLHNCQUFzQjtJQUM5Qix1Q0FBYSxDQUFBO0lBQ2IsbURBQXlCLENBQUE7QUFDN0IsQ0FBQyxFQUhXLHNCQUFzQixHQUF0Qiw4QkFBc0IsS0FBdEIsOEJBQXNCLFFBR2pDO0FBQUEsQ0FBQztBQVNGLElBQVksU0FHWDtBQUhELFdBQVksU0FBUztJQUNqQixzQ0FBeUIsQ0FBQTtJQUN6Qiw0QkFBZSxDQUFBO0FBQ25CLENBQUMsRUFIVyxTQUFTLEdBQVQsaUJBQVMsS0FBVCxpQkFBUyxRQUdwQiJ9